import { Button } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  padding: 64px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  padding-top: 24px;
`;

export const StyledButton = styled(Button)`
  width: 200px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
  color: #263465 !important;
  border: 1px solid rgba(38, 52, 101, 0.50) !important;
  gap: 8px;
  
  &:hover {
    background-color: var(--luft-primary-darker);
  }
`;
